//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        placeholder: {
            type: String
        },
        id: {
            type: String
        },
        value: {
            type: String
        },
        format: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            price_min: "",
            price_max: "",
            prices: [
                { min: null, max: 500000, text: "Hasta $500.000" },
                { min: 500000, max: 1000000, text: "$500.000 a $1.000.000" },
                { min: 1000000, max: 5000000, text: "$1.000.000 a $5.000.000" },
                { min: 5000000, max: null, text: "Más de $5.000.000" },
            ]
        };
    },
    mounted() {
        if (this.value) {
            var value = this.formatNumber(this.value.toLocaleString());
            document.getElementById(this.id).value = value;
        }
    },
    methods: {
        formatNumber(value) {
            value = value.replace(/[^0-9]+/g, "");
            if(this.format){
                value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
            return value;
        },
        handleInput(e) {
            var value = e.target.value;
            if (value) {
                value = this.formatNumber(value);
                document.getElementById(this.id).value = value;
                this.$emit("input", parseInt(value.replace(/\./g, "")));
            }
            else {
                this.$emit("input", value);
            }
            this.$emit("clearError");
        }
    }
}
